export const iconFontAwesomeMovingBoxesPacking = (
	<i className="fa-solid fa-boxes-packing"></i>
);
